import { z } from "zod";

export const STATUS_TYPES = ["active", "closed", "archived"] as const;
export type StatusType = (typeof STATUS_TYPES)[number];

export const statusTypeSchema = z.enum(STATUS_TYPES).optional().default("active");

export const CANDIDATE_STATUS_TYPES = [...STATUS_TYPES, "placed"] as const;
export type CandidateStatusType = (typeof CANDIDATE_STATUS_TYPES)[number];

export const candidateStatusTypeSchema = z.enum(CANDIDATE_STATUS_TYPES).optional().default("active");
